









import { Component, Prop, Vue } from 'vue-property-decorator';
import { Warning } from '@/pages/profile/components';
import MentoringRequestList from '../../requestslist';
import { REQUEST_WARNING } from '@/pages/profile/modules';
import { Requests, IMentoringAllRequests } from './types';

@Component({
  components: {
    Warning,
    MentoringRequestList,
  },
})
export default class MentoringAllRequests extends Vue
  implements IMentoringAllRequests {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Requests;

  public warningText: string = REQUEST_WARNING;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/views/allrequests/MentoringAllRequests.vue